import api from "./api";

// The driver guide videos per language - the trip message guide and the Driver App guide. Manage
// Bookings puts the chosen language's videos into the Copy Driver Message; English is the default.
export const DRIVER_GUIDE_LANGUAGES = [
  { code: "EN", label: "English" },
  { code: "KN", label: "Kannada" },
  { code: "TA", label: "Tamil" },
  { code: "HI", label: "Hindi" },
];

// How each language is named next to its Driver App video in the driver's message: in its own
// script, so a driver spots theirs, with the English name for staff.
export const DRIVER_APP_VIDEO_LABELS = {
  EN: "English",
  KN: "ಕನ್ನಡ (Kannada)",
  TA: "தமிழ் (Tamil)",
  HI: "हिंदी (Hindi)",
};

// Where drivers install the app from. Stable on purpose: the published APK is replaced behind it.
export const DRIVER_APP_DOWNLOAD_URL = "https://www.iotrips.in/app/iotrips-driver.apk";

export async function listDriverGuideVideos() {
  const { data } = await api.get("/api/admin/driver-guide-videos");
  return Array.isArray(data) ? data : [];
}

export async function saveDriverGuideVideos(links) {
  const { data } = await api.put("/api/admin/driver-guide-videos", links);
  return Array.isArray(data) ? data : [];
}
